import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class ThemesParser implements Parser {
	parse(schema: Array<Schema.ThemeEntry>) {
		return Array.isArray(schema) && !!schema.length
			? `export type Themes = ${schema
					.map((entry) => `"${entry.value}"`)
					.join("|")}`
			: "";
	}
}

export class SubthemesParser implements Parser {
	parse(schema: Array<string>) {
		return Array.isArray(schema) && !!schema.length
			? `export type Subthemes = ${schema
					.map((entry) => `"${entry}"`)
					.join("|")}`
			: "";
	}
}
